/**
 * Classificação é derivada pelo backend a partir de RSPDPTCOD + RSPTPFCOD e
 * chega pronta no DTO `IStoreUserRecord.classification`.
 */
export type ClassificationValue = "Desconto" | "Caixa" | "Tesouraria" | "-";

export interface ClassificationOption {
  value: ClassificationValue;
  label: string;
}

export const CLASSIFICATION_OPTIONS: ClassificationOption[] = [
  { value: "Desconto", label: "Desconto (1/1)" },
  { value: "Caixa", label: "Caixa (4/4)" },
  { value: "Tesouraria", label: "Tesouraria (4/12)" },
  { value: "-", label: "Indefinido (-)" },
];

export interface SituationOption {
  value: string;
  label: string;
}

/**
 * Valores de SITUACAO conhecidos no Sênior — alinhados com o enum canônico
 * `EmployeeSituation` em `src/constants/employee-situation.ts`. Backend aceita
 * qualquer valor via passthrough; a lista aqui é só a UX do dropdown.
 */
export const SITUATION_OPTIONS: readonly SituationOption[] = [
  { value: "1. Trabalhando", label: "Trabalhando" },
  { value: "2. Férias", label: "Férias" },
  { value: "3. Auxílio Doença", label: "Auxílio Doença" },
  { value: "6. Licença Maternidade", label: "Licença Maternidade" },
  { value: "7. Demitido", label: "Demitido" },
  { value: "10. Lic. Rem. p/ Funcion.", label: "Licença Remunerada" },
  { value: "122. Aposentadoria p/ Invalidez", label: "Aposentadoria por Invalidez" },
] as const;
